/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import {
    Paper,
    Box,
    Tabs,
    Tab,
    Grid
} from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';

import get from "lodash/get";
import includes from "lodash/includes";

import Layout from "../../../components/layout/Layout";
import Form from "./Form";
import DetailForm from "./FormDetail";
import History from "./History";
import DeliveryPoints from "./DeliveryPoints";
import Costs from "./Costs";
import Payment from './Payment';
import Tracking from './tracking';
import { useCanView } from "../../../config/hook/UserPermissions";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {<Box key={value}>
                {value === index && children}
            </Box>}
        </div>
    );
}

const NewEdit = () => {
    const [__] = useTranslation("route");
    const location = useLocation();
    const { id } = useParams();
    const isEdit = !includes(get(location, "pathname"), "/detail/");
    const [value, setValue] = React.useState(0);
    const [btns, setBtns] = useState(<></>);
    const canView = useCanView(); 

    const [btnCount, setBtnCount] = useState(0);

    useEffect(() => {
        if (btns && React.isValidElement(btns)) {
            const childrenArray = React.Children.toArray(btns.props.children);
    
            const buttonCount = childrenArray.filter((child) => {
                return (
                    React.isValidElement(child) && 
                    child.props?.variant &&       
                    typeof child.props.children === "string"
                );
            }).length;
    
            setBtnCount(buttonCount); 
            console.log(buttonCount)
        }
    }, [btns]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabs = [
        {
            label: __(`tabs.route`),
            component: isEdit ? <Form setBtns={setBtns} /> : <DetailForm setBtns={setBtns} />,
            visible: true, 
        },
        {
            label: __(`tabs.deliveryPoint`),
            component: <DeliveryPoints setBtns={setBtns} isEdit={isEdit} />,
            visible: canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA", "watch"),
        },
        {
            label: __(`tabs.payment`),
            component: <Payment setBtns={setBtns} isEdit={isEdit} />,
            visible: canView("TRANSACCIONES/RUTAS/COBROS", "watch"),
        },
        {
            label: __(`tabs.costs`),
            component: <Costs setBtns={setBtns} isEdit={isEdit} />,
            visible: canView("TRANSACCIONES/RUTAS/COSTOS", "watch"),
        },
        {
            label: __(`tabs.traking`),
            component: <Tracking setBtns={setBtns} isEdit={isEdit} />,
            visible: canView("TRANSACCIONES/RUTAS/TRACKING", "watch"),
        },
    ];


    const visibleTabs = tabs.filter(tab => tab.visible);

    return (
        <Layout
            propsToolbar={{
                title: isEdit ? __(`head.edit.name`) : __(`head.detail.name`),
                srute: isEdit ? __(`head.edit.code`) : __(`head.detail.code`),
            }}
        >
            <Box display="block">
                <Box className="ml-4 mr-0">
                    <Grid className="py-2" container component={Paper} spacing={2}>
                        <Grid item xs={12} lg={btnCount >= 5 ? 5 : 6}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                aria-label="scrollable force tabs example"
                            >
                                {visibleTabs.map((tab, index) => (
                                    <Tab key={index} label={tab.label} />
                                ))}
                            </Tabs>
                        </Grid>
                        <Grid item xs={12} lg={btnCount >= 5 ? 7 : 6}>
                            {btns}
                        </Grid>
                    </Grid>
                </Box>
                {visibleTabs.map((tab, index) => (
                    <TabPanel key={index} value={value} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Box>
        </Layout>
    );
}

export default NewEdit;
